// extracted by mini-css-extract-plugin
module.exports = {"dotloader":"_1bKuS6Gfm2mFFvt9WnMqHF","bouncedelay":"_1ggTtfNIWIgwJiXTf7Ty7k","dotloader1":"_3ZvYNriH0lvzjHXgUcZ3zj","dotloader2":"_3R5tZCfN4kMBRaSnqV0VA3"};